const r = (e, t) => {
  var a;
  return parseFloat((a = e.data[t]) == null ? void 0 : a.impactValue.replace(/[^\d.-]/g, ""));
};
export {
  r as miniImpactBarCellValueGetter
};
//# sourceMappingURL=index.es635.js.map
